// extracted by mini-css-extract-plugin
export default {"img":"Capsules_img__U2Le5"};